<template>
  <div class="score-drawer-filter">
    <ts-loading-banner :loading="loading">
      <div class="filter-field">
        <label>{{ $t('totalScoreGenerate.branchName') }}</label>
        <ts-branch-filter :multiple="false" @filter="setBranchList" class="ts-w-full" ref="branch" />
      </div>

      <div class="filter-field">
        <label>{{ $t('totalScoreGenerate.academicYear') }}</label>
        <a-select style="width: 100%" v-model="acYearId" :options="acYearOptions" :show-search="true"
          @change="onAcYearChange" :filter-option="filterOption"></a-select>
      </div>

      <div class="filter-field">
        <label>{{ $t('totalScoreGenerate.mainProgram') }}</label>
        <a-select style="width: 100%" :disabled="!acYearId" v-model="acpId" :options="mainProgram" @change="getTerm"
          :show-search="true" :filter-option="filterOption" allowClear></a-select>
      </div>

      <div class="filter-field">
        <label>{{ $t('totalScoreGenerate.academicTerm') }}</label>
        <a-select style="width: 100%" v-model="acTermId" :options="termLists" :show-search="true"
          :filter-option="filterOption" @change="fetchClass" allowClear></a-select>
      </div>

      <div class="filter-field">
        <label>{{ $t('totalScoreGenerate.className') }}</label>
        <a-select style="width: 100%" v-model="acClassId" :options="classList" :show-search="true"
          :filter-option="filterOption" allowClear></a-select>
      </div>

      <div class="filter-field filter-field-last">
        <label>{{ $t('totalScoreGenerate.scoringCycle') }}</label>
        <a-select style="width: 100%" v-model="cycle" :show-search="true" :filter-option="filterOption" allowClear>
          <a-select-option :value="5">{{ $t('generatetotalscore.unit') }}</a-select-option>
          <a-select-option :value="0">{{ $t('generatetotalscore.termlyScore') }}</a-select-option>
          <a-select-option :value="7">{{ $t('generatetotalscore.termly') }}</a-select-option>
          <a-select-option :value="1">{{ $t('generatetotalscore.monthlyScore') }}</a-select-option>
          <a-select-option :value="6">{{ $t('generatetotalscore.monthlyForSemester') }}</a-select-option>
          <a-select-option :value="2">{{ $t('generatetotalscore.semesterScore') }}</a-select-option>
          <a-select-option :value="3">{{ $t('generatetotalscore.semesterly') }}</a-select-option>
          <a-select-option :value="4">{{ $t('generatetotalscore.yearly') }}</a-select-option>
        </a-select>
      </div>

      <div class="filter-divider"></div>

      <section class="filter-panel result-panel">
        <div class="filter-panel-header">
          <div>
            <span class="filter-panel-title">{{ $t('totalScoreGenerate.resultStatus') }}</span>
            <span class="filter-alert-badge">{{ $t('totalScoreGenerate.attentionFilter') }}</span>
          </div>
          <span class="filter-quick-label">{{ $t('totalScoreGenerate.quickAction') }}</span>
        </div>
        <a-radio-group v-model="resultStatus" button-style="solid" size="small" class="result-status-options">
          <a-radio-button :value="null"><span class="result-status-label">{{ $t('totalScoreGenerate.all') }}</span></a-radio-button>
          <a-radio-button value="passed"><span class="result-status-label">{{ $t('totalScoreGenerate.passOnly') }}</span></a-radio-button>
          <a-radio-button value="failed"><span class="result-status-label">{{ $t('totalScoreGenerate.failed') }}</span></a-radio-button>
        </a-radio-group>
        <p class="filter-helper-text">{{ $t('totalScoreGenerate.resultStatusHelper') }}</p>
      </section>

      <section class="filter-panel rank-panel">
        <div class="filter-panel-header">
          <span class="filter-panel-title">{{ $t('totalScoreGenerate.studentRankFilter') }}</span>
          <button type="button" class="reset-rank" @click="resetRank">{{ $t('totalScoreGenerate.resetRank') }}</button>
        </div>
        <div class="rank-presets">
          <button
            type="button"
            :class="['rank-chip', { active: rankPreset === 'top3' }]"
            @click="selectRankPreset('top3')"
          >
            {{ $t('totalScoreGenerate.top3') }}
          </button>
          <button
            type="button"
            :class="['rank-chip', { active: rankPreset === 'top5' }]"
            @click="selectRankPreset('top5')"
          >
            {{ $t('totalScoreGenerate.top5') }}
          </button>
          <button
            type="button"
            :class="['rank-chip', { active: rankPreset === 'top10' }]"
            @click="selectRankPreset('top10')"
          >
            {{ $t('totalScoreGenerate.top10') }}
          </button>
        </div>
        <div class="rank-range">
          <div>
            <label>{{ $t('totalScoreGenerate.fromRank') }}</label>
            <input v-model="rankFrom" type="number" min="1" @input="rankPreset = null" />
          </div>
          <div>
            <label>{{ $t('totalScoreGenerate.toRank') }}</label>
            <input v-model="rankTo" type="number" min="1" @input="rankPreset = null" />
          </div>
        </div>
        <p class="filter-helper-text">{{ $t('totalScoreGenerate.rankFilterHelper') }}</p>
      </section>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'drawerFilter',
  data() {
    return {
      loading: false,
      acYearOptions: [],
      mainProgram: [],
      termLists: [],
      classList: [],
      branchId: undefined,
      rankPreset: null
    }
  },
  created() {
    this.fetchAcYear()
  },
  computed: {
    cycle: {
      get() {
        return this.$store.state.generateTotalScore.scoring_cycle_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_SCORING_CYCLE_ID', newValue)
      }
    },
    acYearId: {
      get() {
        return this.$store.state.generateTotalScore.ac_year_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_AC_YEAR_ID', newValue)
      }
    },
    acpId: {
      get() {
        return this.$store.state.generateTotalScore.acp_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_MAIN_PROGRAM', newValue)
      }
    },
    acTermId: {
      get() {
        return this.$store.state.generateTotalScore.ac_term_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_AC_TERM_ID', newValue)
      }
    },
    acClassId: {
      get() {
        return this.$store.state.generateTotalScore.class_id
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_CLASS_ID', newValue)
      }
    },
    resultStatus: {
      get() {
        return this.$store.state.generateTotalScore.result_status
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_RESULT_STATUS', newValue)
      }
    },
    rankFrom: {
      get() {
        return this.$store.state.generateTotalScore.rank_from
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_RANK_FROM', newValue)
      }
    },
    rankTo: {
      get() {
        return this.$store.state.generateTotalScore.rank_to
      },
      set(newValue) {
        this.$store.commit('generateTotalScore/SET_RANK_TO', newValue)
      }
    },
    getStatusTextById() {
      return statusId => {
        const status = {
          1: this.$t('totalScoreGenerate.current'),
          2: this.$t('totalScoreGenerate.history'),
          3: this.$t('totalScoreGenerate.next')
        }

        return status[statusId] || this.$t('totalScoreGenerate.unknown')
      }
    }
  },
  methods: {
    ...mapActions('generateTotalScore', ['formViewModel']),
    async fetchAcYear() {
      this.loading = true
      await this.formViewModel({
        fnName: 'academicYear',
        branchId: this.branchId
      })
        .then(response => {
          this.acYearOptions = response.academicYear.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year + ' - ' + this.getStatusTextById(el.ac_status_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('generateTotalScore/getMainProgram')
        .then(response => {
          this.mainProgram = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    async fetchClass() {
      this.loading = true
      this.acClassId = null
      this.formViewModel({
        fnName: 'academicClass',
        ac_term_id: this.acTermId
      })
        .then(response => {
          this.classList = response.academicClass.map(el => ({
            value: el.class_id,
            label: el.class_name + ' | ' + el.class_desc
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    setBranchList(branch) {
      this.branchId = branch
      this.$store.commit('generateTotalScore/SET_BRANCH_LIST', branch)
      this.fetchAcYear()
      this.acTermId = null
      this.acClassId = null
      this.acYearId = null
      this.acpId = null
    },
    getTerm() {
      this.loading = true
      this.acTermId = null
      this.acClassId = null
      this.formViewModel({
        fnName: 'academicTerm',
        ac_year_id: this.acYearId,
        acp_id: this.acpId,
        branchId: this.branchId
      })
        .then(response => {
          this.termLists = response.academicTerm.map(el => ({
            value: el.ac_term_id,
            label: el.term_name + ' - ' + this.getStatusTextById(el.ac_status_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    },
    clear() {
      const branch = this.$refs.branch
      if (branch) {
        branch.value = []
        this.branchId = undefined
      }

      this.resultStatus = null
      this.rankPreset = null
      this.rankFrom = null
      this.rankTo = null
      this.fetchAcYear()
    },
    onAcYearChange() {
      this.acpId = null
      this.getTerm()
    },
    selectRankPreset(preset) {
      const ranges = {
        top3: [1, 3],
        top5: [1, 5],
        top10: [1, 10]
      }

      this.rankPreset = preset
      this.rankFrom = ranges[preset][0]
      this.rankTo = ranges[preset][1]
    },
    resetRank() {
      this.rankPreset = null
      this.rankFrom = null
      this.rankTo = null
    }
  }
}
</script>

<style scoped>
.score-drawer-filter {
  color: #101828;
}

.filter-field {
  margin-bottom: 12px;
}

.filter-field-last {
  margin-bottom: 14px;
}

.filter-field > label,
.rank-range label {
  display: block;
  margin-bottom: 5px;
  color: #344054;
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
}

.filter-divider {
  margin: 1px 0 15px;
  border-top: 1px dashed #e4e7ec;
}

.filter-panel {
  padding: 11px 10px 9px;
  border: 1px solid #e4e7ec;
  border-radius: 6px;
  background: #f8fafc;
}

.result-panel {
  margin-bottom: 14px;
}

.filter-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.filter-panel-title {
  color: #101828;
  font-size: 11px;
  font-weight: 800;
  line-height: 15px;
}

.filter-alert-badge {
  display: inline-flex;
  align-items: center;
  height: 14px;
  margin-left: 5px;
  padding: 0 5px;
  border-radius: 3px;
  background: #fee4e2;
  color: #d92d20;
  font-size: 7px;
  font-weight: 800;
}

.filter-quick-label,
.reset-rank {
  color: #667085;
  font-size: 9px;
  line-height: 13px;
}

.reset-rank {
  border: 0;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
}

.result-status-options {
  width: 100%;
}

.result-status-label {
  font-size: 10px;
  font-weight: 600;
}

.filter-helper-text {
  margin: 7px 0 0;
  color: #667085;
  font-size: 9px;
  line-height: 13px;
}

.rank-presets {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 10px;
}

.rank-chip {
  height: 23px;
  padding: 0 10px;
  border: 1px solid #d0d5dd;
  border-radius: 5px;
  background: #ffffff;
  color: #344054;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.rank-chip.active {
  border-color: #2563eb;
  background: #2563eb;
  color: #ffffff;
}

.rank-range {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.rank-range input {
  width: 100%;
  height: 25px;
  padding: 0 8px;
  border: 1px solid #d0d5dd;
  border-radius: 5px;
  color: #101828;
  font-size: 11px;
}


.reset-rank:focus,
.rank-chip:focus,
.rank-range input:focus {
  outline: none;
  box-shadow: none;
}

</style>
